import React, { useState, useEffect, useContext } from 'react';
import { Row, Col, Form } from 'react-bootstrap';
import { FilterContext, FilterDispatchContext } from "../context/FilterContext";
import { FilterDataState, FilterComponentProps, ChartComponentProps, CustomTooltipProps } from '../types/type';
import Filters from "./Filters";
import {
    AreaChart,
    Area,
    XAxis,
    YAxis,
    CartesianGrid,
    Label,
    ResponsiveContainer,
    Tooltip
} from "recharts";

export default ({
    sectionType
}: {
    sectionType: string
}) => {
    const filterState = useContext(FilterContext);
    const filterDispatchState = useContext(FilterDispatchContext);

    const parseFilters = () => {
        let portFiltered: string = "";
        if (filterState.filterData && filterState.selectedPort && filterState.selectedPort !== "-" && filterState.selectedPort !== "0") {
            portFiltered = (filterState.filterData.portData.find((data) => data.ID === parseInt(filterState.selectedPort!)))!.Name
        }
        let categoryFiltered: string = "";
        if (filterState.filterData && filterState.selectedCategory && filterState.selectedCategory !== "-" && filterState.selectedCategory !== "0") {
            categoryFiltered = (filterState.filterData.categoryData.find((data) => data.ID === parseInt(filterState.selectedCategory!)))!.Name
        }
        let typeFiltered: string = "";
        if (filterState.filterData && filterState.selectedType && filterState.selectedType !== "-" && filterState.selectedType !== "0") {
            typeFiltered = (filterState.filterData.typeData.find((data) => data.ID === parseInt(filterState.selectedType!)))!.Name
        }
        return (
            <React.Fragment >
                {
                    portFiltered &&
                    <Row style={{ marginLeft: "10px", marginTop: "2px", marginBottom: "2px" }}>
                        <span>{`${portFiltered && "Porto: " + portFiltered}`}</span>
                    </Row>
                }
                {
                    categoryFiltered &&
                    <Row style={{ marginLeft: "10px", marginTop: "2px", marginBottom: "2px" }}>
                        <span>{`${categoryFiltered && "Categoria: " + categoryFiltered}`}</span>
                    </Row>
                }
                {
                    typeFiltered &&
                    <Row style={{ marginLeft: "10px", marginTop: "2px", marginBottom: "2px" }}>
                        <span>{`${typeFiltered && "Item: " + typeFiltered}`}</span>
                    </Row>
                }
            </React.Fragment>

        )
    }

    return (
        <React.Fragment>
            <Row style={{ margin: "10px" }}>
                <h3>Quantidade de registos {sectionType == "collected" ? "registados" : "entregues"} por dia</h3>
            </Row>
            {parseFilters()}
            <Row style={{ marginTop: "10px" }}>
                <Col xs={8} style={{ height: "400px" }}>
                    <Chart
                        filterState={filterState}
                        sectionType={sectionType}
                    />
                </Col>
                <Col>
                    FILTROS 
                    <Filters
                        sectionType={sectionType}
                    />
                </Col>
            </Row>
        </React.Fragment>
    )
}

const Chart = ({
    filterState,
    sectionType
}: ChartComponentProps) => {
    const [chartData, setChartData] = useState<[]>([]);

    useEffect(() => {
        async function init() {
            let parseByTypeID: number[] = [];
            let parseByPortID: number[] = [];

            if (filterState.selectedPort && filterState.selectedPort !== "-" && filterState.selectedPort !== "0") { parseByPortID = [parseInt(filterState.selectedPort!)] }
            if (filterState.filterData && filterState.selectedCategory && filterState.selectedCategory !== "-" && filterState.selectedCategory !== "0") {
                parseByTypeID = filterState.filterData.typeData.filter((type) => {
                    return type.ParentID === parseInt(filterState.selectedCategory!)
                }).map((type) => type.ID);
            }
            if (filterState.selectedType && filterState.selectedType !== "-" && filterState.selectedType !== "0") { parseByTypeID = [parseInt(filterState.selectedType!)] }

            const response = await fetch(process.env.REACT_APP_BACKEND_URL + `/kpi/issue-quantity`, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    byTypeID: parseByTypeID,
                    byPortID: parseByPortID,
                    isDelivered: sectionType === "delivered" ? true : false,
                    startDate: filterState.selectedStartDate.toISOString().split("T")[0],
                    endDate: filterState.selectedEndDate.toISOString().split("T")[0],
                })
            });
            setChartData((await response.json()).results.map((result) => {
                return {
                    name: result.reportedDate.split("T")[0],
                    uv: result.count,
                    //pv: 2400,
                    //amt: 2400
                }
            }));
        }
        init()
    }, [filterState.selectedPort, filterState.selectedCategory, filterState.selectedType, filterState.selectedStartDate, filterState.selectedEndDate])

    const CustomTooltip = ({ active, payload, label }: CustomTooltipProps) => {
        if (active && payload && payload.length) {
            return (
                <div
                    className="recharts-default-tooltip"
                    style={{ margin: "0px", padding: "10px", backgroundColor: "rgb(255, 255, 255)", border: "1px solid rgb(204, 204, 204)", "whiteSpace": "nowrap" }}>
                    <p className="recharts-tooltip-label" style={{ margin: "0px" }}>{`Data: ${label}`}</p>
                    <p className="recharts-tooltip-label" style={{ margin: "0px" }}>{`Quantidade: ${payload[0].value}`}</p>
                </div>
            );
        }

        return null;
    }

    return (
        <ResponsiveContainer height='100%' width='99%'>
            <AreaChart
                width={800}
                height={800}
                data={chartData}
                margin={{
                    top: 10,
                    right: 10,
                    left: 10,
                    bottom: 10
                }}
            >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" tick={chartData.length > 0 ? true : false}>
                    <Label value='Data' position="insideBottom" dy={10} />
                </XAxis>
                <YAxis dataKey="uv">
                    <Label angle={-90} value='Quantidade' position='insideLeft' style={{ textAnchor: 'middle' }} />
                </YAxis>
                {
                    //@ts-ignore
                    <Tooltip content={<CustomTooltip />} />
                }
                <Area type="monotone" dataKey="uv" stroke="#8884d8" fill="#8884d8">
                </Area>
            </AreaChart>
        </ResponsiveContainer>
    )
}

